/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import unitOfMeasureService from './../../../../services/unitOfMeasure';
import unitOfMeasureTransformer from './../../../../transformers/unitOfMeasure';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        code: {
          value: '',
          type: 'text',
        },
      }),
      loading: true,
      tabIndex: 'first',
    };
  },

  computed: {
  },

  watch: {
  },

  created() {
     this.loading = false;
  },

  methods: {
    /**
     * Method to store the client
     */
    store() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const client = unitOfMeasureTransformer.send(
        Object.assign({}, this.formBasicInformation.data())
      );
      unitOfMeasureService.store(client)
      .then(() => {
        this.$message({
          message: this.$t('static.unitOfMeasure.create.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'unitOfMeasure.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formBasicInformation.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/unitOfMeasure/create/create.js